import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

export default function UnterstuetzungAnfragenPage() {
  return (
    <div className="bg-white" style={{ fontFamily: 'Inter, -apple-system, sans-serif' }}>
      {/* Hero */}
      <section className="py-24 md:py-32 bg-gradient-to-b from-[#FAF9F7] to-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="max-w-3xl">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Unterstützung anfragen
            </span>
            <h1 className="text-4xl md:text-[52px] font-bold text-gray-900 leading-tight tracking-tight mb-6">
              Stellen Sie uns Ihr Vorhaben vor.
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Sie engagieren sich in einer Selbsthilfegruppe, Initiative oder einem Projekt 
              und möchten Menschen aus dem neurodiversen Spektrum und ihre Familien unterstützen? 
              Wir freuen uns auf Ihre Anfrage.
            </p>
          </div>
        </div>
      </section>

      {/* Was wir brauchen */}
      <section className="py-24 md:py-32">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
                Was wir von Ihnen wissen möchten:
              </h2>
              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="w-8 h-8 rounded-full bg-[#C4A962]/10 flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-[#C4A962] font-semibold text-sm">1</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Wer sind Sie?</h3>
                    <p className="text-gray-600 text-sm">Selbsthilfegruppe, Initiative, Einrichtung oder Projekt?</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-8 h-8 rounded-full bg-[#C4A962]/10 flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-[#C4A962] font-semibold text-sm">2</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Was ist Ihr Vorhaben?</h3>
                    <p className="text-gray-600 text-sm">Beschreiben Sie kurz, was Sie tun oder planen.</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-8 h-8 rounded-full bg-[#C4A962]/10 flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-[#C4A962] font-semibold text-sm">3</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Wen erreichen Sie?</h3>
                    <p className="text-gray-600 text-sm">Welche Menschen profitieren von Ihrer Arbeit?</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-8 h-8 rounded-full bg-[#C4A962]/10 flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-[#C4A962] font-semibold text-sm">4</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Welche Unterstützung suchen Sie?</h3>
                    <p className="text-gray-600 text-sm">Finanzielle Förderung, Räume, Material, Vernetzung oder Entwicklung?</p>
                  </div>
                </div>
              </div>

              <div className="mt-10 p-6 bg-[#FAF9F7] rounded-xl border border-[#E8E4DE]">
                <p className="text-sm text-gray-600">
                  <strong className="text-gray-900">Hinweis:</strong> Nicht jede Anfrage kann finanziell 
                  gefördert werden. Welche Unterstützung möglich ist, wird individuell geprüft. 
                  Wir melden uns in der Regel innerhalb weniger Werktage bei Ihnen.
                </p>
              </div>
            </div>

            {/* Kontakt-Card */}
            <div>
              <div className="bg-white border border-[#E8E4DE] rounded-2xl p-8 md:p-10 shadow-sm">
                <div className="text-center mb-8">
                  <div className="w-16 h-16 rounded-full bg-[#C4A962]/10 flex items-center justify-center mx-auto mb-4">
                    <Mail className="w-7 h-7 text-[#C4A962]" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Per E-Mail anfragen</h3>
                  <p className="text-gray-600 text-sm">
                    Schreiben Sie uns Ihr Anliegen und wir melden uns bei Ihnen.
                  </p>
                </div>

                <a 
                  href="mailto:we@ask-mi.com?subject=Anfrage%20Unterstützung%20/%20Förderung"
                  className="block w-full bg-gray-900 hover:bg-gray-800 text-white text-center py-4 rounded-lg font-semibold transition-colors mb-4"
                >
                  we@ask-mi.com
                </a>

                <p className="text-xs text-gray-500 text-center">
                  Bitte beschreiben Sie in Ihrer E-Mail kurz Ihr Vorhaben und welche Art von 
                  Unterstützung Sie suchen.
                </p>
              </div>

              <div className="mt-8 text-center">
                <p className="text-sm text-gray-500 mb-4">Sie möchten asK-mi unterstützen?</p>
                <Link 
                  to="/foerderer-werden"
                  className="text-[#A8923F] font-medium hover:underline"
                >
                  Förderer werden →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bereiche */}
      <section className="py-24 md:py-32 bg-[#FAF9F7]">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              Wofür Unterstützung möglich ist
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white rounded-xl p-6 border border-[#E8E4DE]">
              <span className="text-2xl mb-3 block">👥</span>
              <h3 className="font-semibold text-gray-900 mb-2">Selbsthilfegruppen</h3>
              <p className="text-sm text-gray-600">Für Menschen mit Neurodiversität und ihre Angehörigen</p>
            </div>
            <div className="bg-white rounded-xl p-6 border border-[#E8E4DE]">
              <span className="text-2xl mb-3 block">👨‍👩‍👧</span>
              <h3 className="font-semibold text-gray-900 mb-2">Familien-Initiativen</h3>
              <p className="text-sm text-gray-600">Angebote für Eltern und Angehörige</p>
            </div>
            <div className="bg-white rounded-xl p-6 border border-[#E8E4DE]">
              <span className="text-2xl mb-3 block">🧑‍🤝‍🧑</span>
              <h3 className="font-semibold text-gray-900 mb-2">Peer-Gruppen</h3>
              <p className="text-sm text-gray-600">Jugendliche und junge Erwachsene, die sich gegenseitig unterstützen</p>
            </div>
            <div className="bg-white rounded-xl p-6 border border-[#E8E4DE]">
              <span className="text-2xl mb-3 block">🏛️</span>
              <h3 className="font-semibold text-gray-900 mb-2">Einrichtungen</h3>
              <p className="text-sm text-gray-600">Organisationen mit konkreten Unterstützungsangeboten</p>
            </div>
            <div className="bg-white rounded-xl p-6 border border-[#E8E4DE]">
              <span className="text-2xl mb-3 block">🚀</span>
              <h3 className="font-semibold text-gray-900 mb-2">Projekte</h3>
              <p className="text-sm text-gray-600">Vorhaben, die neue Wege für Teilhabe entwickeln</p>
            </div>
            <div className="bg-white rounded-xl p-6 border border-[#E8E4DE]">
              <span className="text-2xl mb-3 block">🔬</span>
              <h3 className="font-semibold text-gray-900 mb-2">Forschung</h3>
              <p className="text-sm text-gray-600">Ansätze, die Neurodiversität besser verstehen helfen</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
